// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { CategoryTypeaheadCategoryFragmentDoc } from '../../typeahead/__generated-gql-types__/CategoryTypeahead.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MultiEventRegistrationModalCoachFragment = {
  __typename?: 'Coach';
  id: string;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
  };
};

export type MultiEventRegistrationModalClassFragment = {
  __typename?: 'Class';
  id: string;
  name?: string | null;
  imageLink?: string | null;
  slug?: string | null;
  isFreeEvent?: boolean | null;
  upcomingSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    totalAttendees: number;
    topFacePiles: Array<string>;
  }> | null;
  coach?: {
    __typename?: 'Coach';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    };
  } | null;
  category?: {
    __typename?: 'Category';
    id: string;
    slug: string;
    goal: Types.GoalName;
    name: string;
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      id: string;
      slug: string;
      v2Urn: string;
      name: string;
    }> | null;
  } | null;
};

export type MultiEventRegistrationModalEventClassFragment = {
  __typename?: 'Class';
  id: string;
  name?: string | null;
  imageLink?: string | null;
  slug?: string | null;
  isFreeEvent?: boolean | null;
  upcomingSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    totalAttendees: number;
    topFacePiles: Array<string>;
  }> | null;
  coach?: {
    __typename?: 'Coach';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    };
  } | null;
  category?: {
    __typename?: 'Category';
    id: string;
    slug: string;
    goal: Types.GoalName;
    name: string;
    subCategoryList?: Array<{
      __typename?: 'SubCategory';
      id: string;
      slug: string;
      v2Urn: string;
      name: string;
    }> | null;
  } | null;
};

export type MultiEventRegistrationModalEventShindigFragment = {
  __typename?: 'Shindig';
  imageLink?: string | null;
  date: number;
  link: string;
  numGuests?: number | null;
  shindigId: string;
  shindigName: string;
  guests?: Array<{ __typename?: 'Guest'; name?: string | null }> | null;
  coaches?: Array<{
    __typename?: 'Coach';
    id: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
    };
  }> | null;
  categories?: Array<{
    __typename?: 'CategorySelection';
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      goal: Types.GoalName;
      name: string;
      subCategoryList?: Array<{
        __typename?: 'SubCategory';
        id: string;
        slug: string;
        v2Urn: string;
        name: string;
      }> | null;
    };
  }> | null;
};

export type MultiEventRegistrationModalEventFragment =
  | MultiEventRegistrationModalEventClassFragment
  | MultiEventRegistrationModalEventShindigFragment;

export type MultiEventRegistrationModalEventsQueryVariables = Types.Exact<{
  categoryFilter:
    | Array<Types.Scalars['CategoryUrn']['input']>
    | Types.Scalars['CategoryUrn']['input'];
}>;

export type MultiEventRegistrationModalEventsQuery = {
  __typename?: 'Query';
  searchClassesAndShindigs: {
    __typename?: 'ClassShindigBatchResponse';
    results: Array<
      | {
          __typename?: 'Class';
          id: string;
          name?: string | null;
          imageLink?: string | null;
          slug?: string | null;
          isFreeEvent?: boolean | null;
          upcomingSessionsV2?: Array<{
            __typename?: 'CoachingSession';
            id: string;
            startAt: number;
            totalAttendees: number;
            topFacePiles: Array<string>;
          }> | null;
          coach?: {
            __typename?: 'Coach';
            id: string;
            user: {
              __typename?: 'User';
              id: string;
              firstName: string;
              lastName: string;
            };
          } | null;
          category?: {
            __typename?: 'Category';
            id: string;
            slug: string;
            goal: Types.GoalName;
            name: string;
            subCategoryList?: Array<{
              __typename?: 'SubCategory';
              id: string;
              slug: string;
              v2Urn: string;
              name: string;
            }> | null;
          } | null;
        }
      | {
          __typename?: 'Shindig';
          imageLink?: string | null;
          date: number;
          link: string;
          numGuests?: number | null;
          shindigId: string;
          shindigName: string;
          guests?: Array<{ __typename?: 'Guest'; name?: string | null }> | null;
          coaches?: Array<{
            __typename?: 'Coach';
            id: string;
            user: {
              __typename?: 'User';
              id: string;
              firstName: string;
              lastName: string;
            };
          }> | null;
          categories?: Array<{
            __typename?: 'CategorySelection';
            category: {
              __typename?: 'Category';
              id: string;
              slug: string;
              goal: Types.GoalName;
              name: string;
              subCategoryList?: Array<{
                __typename?: 'SubCategory';
                id: string;
                slug: string;
                v2Urn: string;
                name: string;
              }> | null;
            };
          }> | null;
        }
    >;
  };
};

export type MultiEventRegistrationModalBatchEnrollMutationVariables =
  Types.Exact<{
    input: Array<Types.Scalars['Urn']['input']> | Types.Scalars['Urn']['input'];
  }>;

export type MultiEventRegistrationModalBatchEnrollMutation = {
  __typename?: 'Mutation';
  batchEnrollShindigsAndClasses: boolean;
};

export const MultiEventRegistrationModalCoachFragmentDoc = gql`
  fragment MultiEventRegistrationModal_Coach on Coach {
    id
    user {
      id
      firstName
      lastName
    }
  }
`;
export const MultiEventRegistrationModalClassFragmentDoc = gql`
  fragment MultiEventRegistrationModal_Class on Class {
    id
    name
    imageLink
    slug
    isFreeEvent
    upcomingSessionsV2 {
      id
      startAt
      totalAttendees
      topFacePiles(count: 3)
    }
    coach {
      ...MultiEventRegistrationModal_Coach
    }
    category {
      ...CategoryTypeahead_Category
    }
  }
  ${MultiEventRegistrationModalCoachFragmentDoc}
  ${CategoryTypeaheadCategoryFragmentDoc}
`;
export const MultiEventRegistrationModalEventFragmentDoc = gql`
  fragment MultiEventRegistrationModal_Event on ClassAndShindig {
    ... on Class {
      ...MultiEventRegistrationModal_Class
    }
    ... on Shindig {
      shindigId: id
      shindigName: name
      imageLink
      date
      link
      numGuests
      guests {
        name
      }
      coaches {
        ...MultiEventRegistrationModal_Coach
      }
      categories {
        category {
          ...CategoryTypeahead_Category
        }
      }
    }
  }
  ${MultiEventRegistrationModalClassFragmentDoc}
  ${MultiEventRegistrationModalCoachFragmentDoc}
  ${CategoryTypeaheadCategoryFragmentDoc}
`;
export const MultiEventRegistrationModalEventsDocument = gql`
  query MultiEventRegistrationModal_Events($categoryFilter: [CategoryUrn!]!) {
    searchClassesAndShindigs(
      includeRelatedCategories: true
      categoryFilter: $categoryFilter
      timeFilter: UPCOMING
      start: 0
      count: 3
      excludeEnrolled: true
      freeEvent: true
    ) {
      results {
        ...MultiEventRegistrationModal_Event
      }
    }
  }
  ${MultiEventRegistrationModalEventFragmentDoc}
`;

/**
 * __useMultiEventRegistrationModalEventsQuery__
 *
 * To run a query within a React component, call `useMultiEventRegistrationModalEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiEventRegistrationModalEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiEventRegistrationModalEventsQuery({
 *   variables: {
 *      categoryFilter: // value for 'categoryFilter'
 *   },
 * });
 */
export function useMultiEventRegistrationModalEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MultiEventRegistrationModalEventsQuery,
    MultiEventRegistrationModalEventsQueryVariables
  > &
    (
      | {
          variables: MultiEventRegistrationModalEventsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MultiEventRegistrationModalEventsQuery,
    MultiEventRegistrationModalEventsQueryVariables
  >(MultiEventRegistrationModalEventsDocument, options);
}
export function useMultiEventRegistrationModalEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MultiEventRegistrationModalEventsQuery,
    MultiEventRegistrationModalEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MultiEventRegistrationModalEventsQuery,
    MultiEventRegistrationModalEventsQueryVariables
  >(MultiEventRegistrationModalEventsDocument, options);
}
export function useMultiEventRegistrationModalEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    MultiEventRegistrationModalEventsQuery,
    MultiEventRegistrationModalEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    MultiEventRegistrationModalEventsQuery,
    MultiEventRegistrationModalEventsQueryVariables
  >(MultiEventRegistrationModalEventsDocument, options);
}
export type MultiEventRegistrationModalEventsQueryHookResult = ReturnType<
  typeof useMultiEventRegistrationModalEventsQuery
>;
export type MultiEventRegistrationModalEventsLazyQueryHookResult = ReturnType<
  typeof useMultiEventRegistrationModalEventsLazyQuery
>;
export type MultiEventRegistrationModalEventsSuspenseQueryHookResult =
  ReturnType<typeof useMultiEventRegistrationModalEventsSuspenseQuery>;
export type MultiEventRegistrationModalEventsQueryResult = Apollo.QueryResult<
  MultiEventRegistrationModalEventsQuery,
  MultiEventRegistrationModalEventsQueryVariables
>;
export const MultiEventRegistrationModalBatchEnrollDocument = gql`
  mutation MultiEventRegistrationModal_BatchEnroll($input: [Urn!]!) {
    batchEnrollShindigsAndClasses(ids: $input)
  }
`;
export type MultiEventRegistrationModalBatchEnrollMutationFn =
  Apollo.MutationFunction<
    MultiEventRegistrationModalBatchEnrollMutation,
    MultiEventRegistrationModalBatchEnrollMutationVariables
  >;

/**
 * __useMultiEventRegistrationModalBatchEnrollMutation__
 *
 * To run a mutation, you first call `useMultiEventRegistrationModalBatchEnrollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMultiEventRegistrationModalBatchEnrollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [multiEventRegistrationModalBatchEnrollMutation, { data, loading, error }] = useMultiEventRegistrationModalBatchEnrollMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMultiEventRegistrationModalBatchEnrollMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MultiEventRegistrationModalBatchEnrollMutation,
    MultiEventRegistrationModalBatchEnrollMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MultiEventRegistrationModalBatchEnrollMutation,
    MultiEventRegistrationModalBatchEnrollMutationVariables
  >(MultiEventRegistrationModalBatchEnrollDocument, options);
}
export type MultiEventRegistrationModalBatchEnrollMutationHookResult =
  ReturnType<typeof useMultiEventRegistrationModalBatchEnrollMutation>;
export type MultiEventRegistrationModalBatchEnrollMutationResult =
  Apollo.MutationResult<MultiEventRegistrationModalBatchEnrollMutation>;
export type MultiEventRegistrationModalBatchEnrollMutationOptions =
  Apollo.BaseMutationOptions<
    MultiEventRegistrationModalBatchEnrollMutation,
    MultiEventRegistrationModalBatchEnrollMutationVariables
  >;
